// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style-module_breadcrumb__3OIl2IG9mdth4RV5Ue081H","breadcrumbLink":"style-module_breadcrumbLink__YP9_EURkgi6JxzMnWqBL0"};